// extracted by mini-css-extract-plugin
module.exports = {"ClaraScoreForm":"ClaraScoreForm_ClaraScoreForm__38Pat","BotoneraContainer":"ClaraScoreForm_BotoneraContainer__3jGl1"};